import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { ListPageChartsResponse } from '../list-page-charts/types';

export const useGetBindingUsersStats = (enabled = true) => {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['binding-users', 'stats', forBinding],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<ListPageChartsResponse>('/binding-users/stats', {
				params: { forBinding },
			});
			return data;
		},
	});
};
